<template>
  <div>
    <WidgetsStatsA id="max" />
    <CRow>
      <CCol :md="12">
        <CCard class="mb-4">
          <CCardBody>
            <br />
            <h3 class="card-title mb-0">
              Клиенты рекламного агентства CSADV 2002-2022
            </h3>
            <hr />
            <CTable align="middle" class="mb-0 border" hover responsive>
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell class="text-center">
                    <CIcon name="cil-people" />
                  </CTableHeaderCell>
                  <CTableHeaderCell>Breand</CTableHeaderCell>
                  <CTableHeaderCell class="text-center"
                    >Country</CTableHeaderCell
                  >
                  <CTableHeaderCell>
                    Использовано услуг агентства
                  </CTableHeaderCell>
                  <CTableHeaderCell class="text-center"
                    >Активности</CTableHeaderCell
                  >
                </CTableRow>
              </CTableHead>
              <CTableBody id="clients">
                <CTableRow v-for="item in tableExample" :key="item.name">
                  <CTableDataCell class="text-center">
                    <CAvatar
                      size="md"
                      :src="item.avatar.src"
                      :status="item.avatar.status"
                    />
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{{ item.user.name }}</div>
                    <div class="small text-medium-emphasis">
                      <span>{{ item.user.new ? 'New' : 'Recurring' }}</span> |
                      {{ item.user.registered }}
                    </div>
                  </CTableDataCell>
                  <CTableDataCell class="text-center">
                    <CIcon
                      size="xl"
                      :name="item.country.flag"
                      :title="item.country.name"
                    />
                  </CTableDataCell>
                  <CTableDataCell>
                    <div class="clearfix">
                      <div class="float-start">
                        <strong>{{ item.usage.value }}%</strong>
                      </div>
                      <div class="float-end">
                        <small class="text-medium-emphasis">
                          {{ item.usage.period }}
                        </small>
                      </div>
                    </div>
                    <CProgress
                      thin
                      :color="item.usage.color"
                      :value="item.usage.value"
                    />
                  </CTableDataCell>
                  <CTableDataCell class="text-center">
                    <CIcon
                      size="xl"
                      v-if="item.payment.tvicon"
                      name="cil-tv"
                      title="Реклама на ТВ"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.newspapericon"
                      name="cil-newspaper"
                      title="Реклама в Прессе"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.audioicon"
                      name="cil-audio"
                      title="Реклама на радио"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.outdooricon"
                      name="cil-border-outer"
                      title="Наружная реклама"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.libraryicon"
                      name="cil-library"
                      title="PR, Связи с общественностью"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.brushicon"
                      name="cil-brush"
                      title="Креатив, Дизайн, Упаковка"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.calendarcheckicon"
                      name="cil-calendar"
                      title="Мероприятия, Выставки"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.hostingicon"
                      name="cil-storage"
                      title="Web-design, hosting"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.peopleicon"
                      name="cil-people"
                      title="Предоставление персонала"
                    />
                    <CIcon
                      size="xl"
                      v-if="item.payment.marketingicon"
                      name="cil-chart-pie"
                      title="Маркетинговые исследования"
                    />
                  </CTableDataCell>
                </CTableRow>
                <CTableRow> </CTableRow>
              </CTableBody>
            </CTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import bpilogo from '@/assets/images/avatars/webp40x40/bpi-logo.webp'
import siempelkamp from '@/assets/images/avatars/webp40x40/img-siempelkamp-logo.webp'
import sbswim from '@/assets/images/avatars/webp40x40/sweet_baby_swim_5.webp'
import rocslogo from '@/assets/images/avatars/webp40x40/rocs-logo.webp'
import gazprombank from '@/assets/images/avatars/webp40x40/gazprombank.webp'
import osetr from '@/assets/images/avatars/webp40x40/osetr.webp'
import escan from '@/assets/images/avatars/webp40x40/logo-escan-antivirus.webp'
import mega from '@/assets/images/avatars/webp40x40/mega.webp'
import centro from '@/assets/images/avatars/webp40x40/centro.webp'
import binatone from '@/assets/images/avatars/webp40x40/binatone.webp'
import autonews from '@/assets/images/avatars/webp40x40/autonews.webp'
import casio from '@/assets/images/avatars/webp40x40/g-shock_casio.webp'
import pioneer from '@/assets/images/avatars/webp40x40/pioneer.webp'
import hankel from '@/assets/images/avatars/webp40x40/hankel.webp'
import stoletov from '@/assets/images/avatars/webp40x40/stoletov.webp'
import aubrey from '@/assets/images/avatars/webp40x40/aubrey.webp'
import tsk from '@/assets/images/avatars/webp40x40/tsk.webp'
import yablohnyyspas from '@/assets/images/avatars/webp40x40/yablohnyyspas.webp'
import catsdogs from '@/assets/images/avatars/webp40x40/cats-n-dogs.webp'
import moedelo from '@/assets/images/avatars/webp40x40/moedelo.webp'
import hitachi from '@/assets/images/avatars/webp40x40/hitachi.webp'
import mitsubishielectric from '@/assets/images/avatars/webp40x40/mitsubishi-electric.webp'
import gama from '@/assets/images/avatars/webp40x40/gama.webp'

import WidgetsStatsA from './widgets/WidgetsStatsTypeA.vue'

export default {
  name: 'Dashboard',
  components: {
    WidgetsStatsA,
  },
  setup() {
    const progressGroupExample1 = [
      { title: 'Monday', value1: 34, value2: 78 },
      { title: 'Tuesday', value1: 56, value2: 94 },
      { title: 'Wednesday', value1: 12, value2: 67 },
      { title: 'Thursday', value1: 43, value2: 91 },
      { title: 'Friday', value1: 22, value2: 73 },
      { title: 'Saturday', value1: 53, value2: 82 },
      { title: 'Sunday', value1: 9, value2: 69 },
    ]
    const progressGroupExample2 = [
      { title: 'Male', icon: 'cil-user', value: 53 },
      { title: 'Female', icon: 'cil-user-female', value: 43 },
    ]
    const progressGroupExample3 = [
      {
        title: 'Organic Search',
        icon: 'cib-google',
        percent: 56,
        value: '191,235',
      },
      { title: 'Facebook', icon: 'cib-facebook', percent: 15, value: '51,223' },
      { title: 'Twitter', icon: 'cib-twitter', percent: 11, value: '37,564' },
      { title: 'LinkedIn', icon: 'cib-linkedin', percent: 8, value: '27,319' },
    ]
    const tableExample = [
      {
        avatar: { src: bpilogo, status: 'success' },
        user: {
          name: 'BPI Group спецтехника',
          new: true,
          registered: 'Jan 17, 2022',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 50,
          period: 'Jun 17, 2022 - наст.вр.',
          color: 'success',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: true,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: true,
          marketingicon: true,
        },
      },
      {
        avatar: { src: siempelkamp, status: 'danger' },
        user: {
          name: 'Siempelkamp',
          new: false,
          registered: 'May 1, 2020',
        },
        country: { name: 'Germany', flag: 'cif-de' },
        usage: {
          value: 22,
          period: 'May 1, 2020 - Jul 10, 2021',
          color: 'info',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: false,
          calendarcheckicon: false,
          peopleicon: true,
          marketingicon: true,
        },
      },
      {
        avatar: { src: sbswim, status: 'warning' },
        user: {
          name: 'Sweet Baby Swim',
          new: true,
          registered: 'Mar 27, 2019',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 74,
          period: 'Mar 27, 2019 - Jul 05, 2021',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: true,
          brushicon: true,
          calendarcheckicon: false,
          peopleicon: true,
          hostingicon: true,
          marketingicon: true,
        },
      },
      {
        avatar: { src: rocslogo, status: 'secondary' },
        user: { name: 'R.O.C.S', new: false, registered: 'Jan 1, 2004' },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 98,
          period: 'Jun 11, 2004 - Noy 15, 2015',
          color: 'danger',
        },
        payment: {
          tvicon: true,
          outdooricon: true,
          audioicon: true,
          newspapericon: true,
          libraryicon: true,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: true,
          marketingicon: true,
        },
      },
      {
        avatar: { src: gama, status: 'secondary' },
        user: { name: 'GA.MA', new: false, registered: '2010' },
        country: { name: 'Italy', flag: 'cif-it' },
        usage: {
          value: 87,
          period: '2010 - 2012',
          color: 'success',
        },
        payment: {
          tvicon: false,
          outdooricon: true,
          audioicon: true,
          newspapericon: true,
          libraryicon: true,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: true,
        },
      },
      {
        avatar: { src: gazprombank, status: 'success' },
        user: {
          name: 'ГазПромБанк',
          new: false,
          registered: 'Jan 1, 2007',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 22,
          period: 'Jan 1, 2007 - Jul 10, 2013',
          color: 'primary',
        },
        payment: { outdooricon: true, newspapericon: true },
      },
      {
        avatar: { src: moedelo, status: 'success' },
        user: {
          name: 'Мое дело сервис бухгалтерии',
          new: true,
          registered: '2010',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 50,
          period: '2010',
          color: 'success',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: true,
          brushicon: true,
          calendarcheckicon: false,
          peopleicon: true,
          hostingicon: false,
          marketingicon: true,
        },
      },
      {
        avatar: { src: casio, status: 'success' },
        user: {
          name: 'Часы g-shock от casio',
          new: true,
          registered: '2010',
        },
        country: { name: 'Япония', flag: 'cif-jp' },
        usage: {
          value: 44,
          period: '2005 - 2008',
          color: 'success',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: true,
          libraryicon: true,
          brushicon: true,
          calendarcheckicon: false,
          peopleicon: false,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: pioneer, status: 'success' },
        user: {
          name: 'Pioneer плазменные телевизоры',
          new: true,
          registered: '2007',
        },
        country: { name: 'Япония', flag: 'cif-jp' },
        usage: {
          value: 22,
          period: '2007',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: true,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: false,
          peopleicon: false,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: hitachi, status: 'success' },
        user: {
          name: 'Hitachi спецтехника',
          new: true,
          registered: '2011',
        },
        country: { name: 'Япония', flag: 'cif-jp' },
        usage: {
          value: 25,
          period: '2011',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: false,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: mitsubishielectric, status: 'success' },
        user: {
          name: 'Mitsubishi Electric',
          new: true,
          registered: '2011',
        },
        country: { name: 'Япония', flag: 'cif-jp' },
        usage: {
          value: 55,
          period: '2011 - 2013',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: true,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: false,
          calendarcheckicon: false,
          peopleicon: false,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: stoletov, status: 'success' },
        user: {
          name: 'Сеть Аптек Доктор Столетов',
          new: false,
          registered: '2006',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 65,
          period: '2006 - 2013',
          color: 'success',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: aubrey, status: 'success' },
        user: {
          name: 'Aubrey Organics',
          new: true,
          registered: '2006',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 69,
          period: '2006 - 2008',
          color: 'success',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: true,
        },
      },
      {
        avatar: { src: tsk, status: 'primary' },
        user: {
          name: 'ТехСтройКонтракт',
          new: true,
          registered: '2006',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 89,
          period: '2006 - 2008',
          color: 'primary',
        },
        payment: {
          tvicon: false,
          outdooricon: true,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: false,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: catsdogs, status: 'success' },
        user: {
          name: 'Зоомагазины Cats and Dogs',
          new: true,
          registered: '2010',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 44,
          period: '2010',
          color: 'success',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: yablohnyyspas, status: 'primary' },
        user: {
          name: 'Яблочный Спас Сидр',
          new: true,
          registered: '2007',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 22,
          period: '2007',
          color: 'primary',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: hankel, status: 'success' },
        user: {
          name: 'Hankel кухонное оборудование',
          new: true,
          registered: '2010',
        },
        country: { name: 'Германия', flag: 'cif-de' },
        usage: {
          value: 22,
          period: '2005 - 2012',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: true,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: false,
          peopleicon: false,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: centro, status: 'warning' },
        user: {
          name: 'Centro обувь',
          new: true,
          registered: '2010',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 44,
          period: '2010 - 2012',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: binatone, status: 'primary' },
        user: {
          name: 'Binatone',
          new: true,
          registered: '2004',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 24,
          period: '2004 - Jul 05, 2011',
          color: 'primary',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: mega, status: 'warning' },
        user: {
          name: 'МЕГА Белая Дача',
          new: true,
          registered: 'Mar 27, 2010',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 24,
          period: 'Mar 27, 2010 - Jul 05, 2010',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: autonews, status: 'warning' },
        user: {
          name: 'Auto News',
          new: true,
          registered: 'Mar 27, 2007',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 24,
          period: 'Mar 27, 2007 - Jul 05, 2007',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: false,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: false,
          marketingicon: false,
        },
      },
      {
        avatar: { src: escan, status: 'warning' },
        user: {
          name: 'eScan Antivirus',
          new: true,
          registered: 'Mar 27, 2010',
        },
        country: { name: 'India', flag: 'cif-in' },
        usage: {
          value: 74,
          period: 'Mar 27, 2010 - Jul 05, 2010',
          color: 'warning',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: false,
          libraryicon: true,
          brushicon: true,
          calendarcheckicon: false,
          peopleicon: false,
          hostingicon: false,
          marketingicon: true,
        },
      },
      {
        avatar: { src: osetr, status: 'danger' },
        user: {
          name: 'Осетров Дмитрий',
          new: false,
          registered: 'Jan 1, 2003',
        },
        country: { name: 'Russia', flag: 'cif-ru' },
        usage: {
          value: 43,
          period: 'Jan 1, 2003 - наст.вр.',
          color: 'success',
        },
        payment: {
          tvicon: false,
          outdooricon: false,
          audioicon: false,
          newspapericon: true,
          libraryicon: true,
          brushicon: true,
          calendarcheckicon: true,
          peopleicon: true,
          hostingicon: true,
          marketingicon: true,
        },
      },
    ]

    return {
      tableExample,
      progressGroupExample1,
      progressGroupExample2,
      progressGroupExample3,
    }
  },
}
</script>
